import registrationTypes from "../constants/user/registrationTypes";

import { fetchResponsiblesAction } from "../../actions/ResponsiblesActions";
import { getResponsiblesState, hasResponsiblesState } from "../../selectors/responsiblesSelectors";
import { getTenantIdState, useUserIdState } from "../../selectors/userInfoSelectors";
import responsibleService from "../../services/responsibleService";
import { handleRequestErrorViolations } from "../handlers/responseErrorHandler";
import reduxStoreHelper from "./reduxStoreHelper";

const changeResponsible = (
  obj: { id: string },
  responsible: { id: string; name: string },
  service: {
    changeResponsible: (
      arg0: string,
      arg1: string,
      arg2: string
    ) => Promise<{ data: Record<string, string> }>;
  }
) => {
  const userId = useUserIdState();

  return service
    .changeResponsible(obj.id, responsible.id, userId)
    .then(({ data }) => ({
      ...obj,
      responsible: responsible.id,
      responsibleId: responsible.id,
      responsibleName: responsible.name,
      version: data.version,
    }))
    .catch(handleRequestErrorViolations);
};

const loadResponsiblesToRedux = () => {
  const tenantId = getTenantIdState(reduxStoreHelper.getState());
  const hasResponsibles = hasResponsiblesState(reduxStoreHelper.getState());

  if (!hasResponsibles) {
    responsibleService.getAllResponsibles(tenantId).then(({ data }) =>
      reduxStoreHelper.dispatch(
        // @ts-ignore
        fetchResponsiblesAction,
        // @ts-ignore
        data.items.filter(({ status }) => status === registrationTypes.ACTIVE)
      )
    );
  }
};

const getResponsibleById = (id: string) => {
  const selectedResponsible = getResponsiblesState(reduxStoreHelper.getState()).find(
    (responsible: { id: string }) => String(responsible.id) === String(id)
  );
  return selectedResponsible || {};
};

const sortResposibleArrayByNickname = (
  { nickname: nicknameA }: { nickname: string },
  { nickname: nicknameB }: { nickname: string }
) => nicknameA.toLowerCase().localeCompare(nicknameB.toLowerCase());

export default {
  changeResponsible,
  loadResponsiblesToRedux,
  getResponsibleById,
  sortResposibleArrayByNickname,
};
